var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"text-xs-center header"},[_vm._v(_vm._s(_vm.$t("BASKET.EMPTY")))])
}
var staticRenderFns = []

export { render, staticRenderFns }